<!-- Barra de COOKIES -->

<cookie-law *ngIf="hasCookieBar" expiration="30">
  {{ 'COOKIES.MESSAGE' | translate}}
  <a [attr.href]="'COOKIES.HREF' | translate" target="_blank">
    {{ 'COOKIES.LINK' | translate}}
  </a>
</cookie-law>

<!-- Si sólo hay un hospital mostramos que estamos pidiendo cita ahí -->

<div *ngIf="environmentName != 'typet' || _userService.user"
  [hidden]="_userService && _userService.user && _userService.user.passInitial">
  <h4 *ngIf="_resourceService.hospitals?.length == 1">{{ 'BOOK_APPOINTMENTS_FOR' | translate}} {{
    _resourceService.hospitals[0].name }}</h4>
  <h4 *ngIf="_resourceService.hospitals?.length > 1">{{ 'BOOK_APPOINTMENTS_FOR' | translate}}:

  </h4>
  <hr>

  <form #forma="ngForm" environmentName=environment.envName;>

    <!-- Loading cuando pedimos algo -->

    <div class="text-center alert background-main-color"
      *ngIf="_resourceService.loading || _userService.loading">
      <i class="fa fa-refresh fa-spin font-size-20"></i>
      <span> {{ 'LOADING' | translate }}...</span>
    </div>

    <div class="alert alert-warning" role="alert" *ngIf="_resourceService.alert">
      {{ _resourceService.alert | translate }}
    </div>

    <!-- Fila pidiendo el hospital si hay más de uno-->

    <div class="form-row">

      <div class="form-group col-md-12" *ngIf="_resourceService.hospitals?.length > 1">
        <label>{{ 'CHOOSE_YOUR_HOSPITAL' | translate}}</label>
        <div class="input-group mb-3">
          <select name="hospital" class="form-control" [(ngModel)]=searchterms.hospitalId
            [disabled]="!_resourceService.hospitals?.length"
            (ngModelChange)="getDepartments($event)">
            <!-- Para explorer 11 -->
            <option *ngIf="!searchterms.hospitalId" [ngValue]="null" selected disabled>
            </option>
            <option *ngFor="let hospital of _resourceService.hospitals" [value]="hospital.id">
              {{ hospital.name }}
            </option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary"
              (click)="searchterms.hospitalId = null; _resourceService.departments = null"
              [disabled]="!searchterms.hospitalId">
              <i class="fas fa-trash-alt icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filas pidiendo datos de búsqueda de slots. Se piden Aseguradora, departament y doctor en una fila,
      y si se incluye búsqueda por subdepartmento se pone en dos filas-->


    <!-- This is showed if we DON'T have subdepartment search -->
    <div *ngIf="!hasSubdepartmentSearch">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>{{ 'PAYOR' | translate}}</label>
          <div class="input-group mb-3">
            <select name="payor" class="form-control" [(ngModel)]=searchterms.payorId
              [disabled]="!_resourceService.payors?.length">
              <!-- Para explorer 11 -->
              <option *ngIf="!searchterms.payorId" [ngValue]="null" selected disabled>
              </option>
              <option *ngFor="let payor of _resourceService.payors" [value]="payor.id">
                {{ payor.name }}
              </option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="searchterms.payorId = null"
                [disabled]="!searchterms.payorId">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>{{ 'DEPARTMENT' | translate}}</label>
          <div class="input-group mb-3">
            <select name="department" class="form-control" [(ngModel)]=searchterms.departmentId
              [disabled]="!_resourceService.departments?.length"
              (ngModelChange)="getConsultants($event)">
              <!-- Para explorer 11 -->
              <option *ngIf="!searchterms.departmentId" [ngValue]="null" selected disabled></option>
              <option *ngFor="let department of _resourceService.departments"
                [value]="department.id">
                {{ department.name}}
              </option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="searchterms.departmentId = null"
                [disabled]="!searchterms.departmentId">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>{{ 'CONSULTANT' | translate}}</label>
          <div class="input-group mb-3">
            <select name="consultant" class="form-control" [(ngModel)]=searchterms.doctorId
              [disabled]="!_resourceService.doctors?.length">
              <!-- Para explorer 11 -->
              <option *ngIf="!searchterms.doctorId" [ngValue]="null" selected disabled></option>
              <option *ngFor="let doctor of _resourceService.doctors" [value]="doctor.id">{{
                doctor.name }}</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="searchterms.doctorId = null"
                [disabled]="!searchterms.doctorId">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group" [ngClass]="hasVideoCall ? 'col-md-4' : 'col-md-6'">
          <label>
            {{ 'DATE' | translate}} *
          </label>
          <div class="input-group mb-3">


            <p-calendar #calendar class="form-control" [(ngModel)]="searchterms.date" name="dp"
              dateFormat="dd-mm-yy" [locale]="locale.localeObject"
              [inputStyle]="{'border':'none', 'font-size': '1em', 'padding': 'initial', 'width': '100px'}"
              [minDate]="tomorrow">
            </p-calendar> <button class="btn btn-outline-secondary fas fa-calendar-alt"
              (click)="calendar.showOverlay()" type="button"></button>

          </div>
        </div>
      </div>
    </div>


    <!-- Filas pidiendo dia y hora para búsqueda de slots. Si tenemos videoCall además pedimos el Visit Type-->

    <div class="form-row">


      <div class="form-group" *ngIf="hasTimeframe"
        [ngClass]="hasVideoCall ? 'col-md-4' : 'col-md-6'">
        <label>{{ 'TIMEFRAME' | translate}}</label>
        <div class="input-group mb-3">
          <select name="timeframe" class="form-control" [(ngModel)]=searchterms.timeframeId>
            <option *ngFor="let timeframe of _resourceService.timeframes" [value]="timeframe.id">{{
              timeframe.name | translate }}</option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="searchterms.timeframeId = null"
              [disabled]="!searchterms.timeframeId">
              <i class="fas fa-trash-alt icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-4" *ngIf="hasVideoCall">
        <label>{{ 'VISIT_TYPE' | translate}}</label>
        <div class="input-group mb-3">
          <select name="visitType" class="form-control" [(ngModel)]=searchterms.visitTypeId>
            <option *ngFor="let visitType of _resourceService.visitTypes" [value]="visitType.id">{{
              visitType.name | translate }}</option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="searchterms.visitTypeId = null"
              [disabled]="!searchterms.visitTypeId">
              <i class="fas fa-trash-alt icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-4">

      </div>
    </div>




    <div class="form-row">
      <div class="form-group col-md-6">
        <button type="submit" class="btn btn-main-color btn-block" (click)="checkSearchTerms()"
          [disabled]="!_resourceService.doctors?.length">
          {{ 'SEARCH' | translate}}
        </button>
      </div>
      <div class="col-md-6">
        <button class="btn btn-secondary-color btn-block" (click)="reset()">
          {{ 'RESET' | translate}}
        </button>
      </div>
    </div>
  </form>

</div>

<div class="container" *ngIf="daySlots">
  <div class="row">
    <div class="col-sm-12 text-center">
      <h4 class="">{{ 'SELECT_YOUR_APPOINTMENT' | translate}}</h4>
      <h4>
        {{ firstDayReturnedShowed }}
      </h4>
      <h6 *ngIf="firstDayReturnedShowed != daySearched" class="highlight">
        {{ 'FIRST_DAY_WITH_SLOTS_AFTER' | translate}}
        {{ daySearched }}
      </h6>
    </div>
  </div>
  <div class="row">
    <div class="col text-left">
      <button *ngIf="daySearchedtoCompare != stringTomorrow" type="submit"
        class="btn btn-main-color margin-top-5" (click)="getPreviosDay()">
        <i class="fas fa-arrow-left"></i> {{ 'PREVIOUS_DAY' | translate}}
      </button>
    </div>

    <div class="col text-right">
      <button type="submit" class="btn btn-main-color margin-top-5" (click)="getNextDay()">
        {{ 'NEXT_DAY' | translate}} <i class="fas fa-arrow-right"></i>
      </button>
    </div>
  </div>
  <div id="container" [@listAnimation]="daySlots">

    <div *ngFor="let doctor of daySlots | keyvalue" [@listAnimation]="state">

      <div class="card sm-12 margin-top">
        <div class="card-header btn-main-color">{{ doctor.value['name'] }}</div>
        <div class="card-body">
          <span *ngFor="let hour of doctor.value | keyvalue">
            <span class="btn btn-secondary-color hour col-1" data-toggle="modal"
              data-target="#FreeSlotModal" (click)="sendFreeslot(hour.value[0])"
              *ngIf="hour.key != 'name'">
              {{ hour.key | slice:0:5 }}</span>
          </span>
        </div>
      </div>

    </div>
  </div>

</div>

<p>&nbsp;</p>

<!-- The FreeSlot Modal -->
<div class="modal fade" id="FreeSlotModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'YOUR_SELECTION' | translate}}</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <!-- Only if have dependents -->
        <div class="alert alert-warning" role="alert" *ngIf="alert">
          {{ alert | translate }}
        </div>
        <div class="card" *ngIf="hasMyDepents && _userService.user?.dependents?.length">
          <div class="card-header btn-main-color">
            {{ 'YOU_HAVE_DEPENDENTS' | translate}}
          </div>
          <div class="card-body">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="isForDependents" id="false"
                [value]="false" [(ngModel)]="isForDependents">
              <label class="
                form-check-label" for="false">{{ 'BOOK_FOR_ME'
                | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="isForDependents" id="true"
                [value]="true" [(ngModel)]="isForDependents">
              <label class="form-check-label" for="true">{{ 'BOOK_FOR_DEPENDENT' |
                translate}}</label>
            </div>
            <div>
              <div class="row margin-top" *ngIf="isForDependents">
                <div class="form-group col-md-12">
                  <label>{{ 'CHOOSE_DEPENDENT' | translate}}</label>
                  <select name="dependent" class="form-control" [(ngModel)]=dependentId>
                    <option *ngFor="let dependent of _userService.user.dependents"
                      [value]="dependent.id">{{
                      dependent.name }} {{ dependent.lastname }} {{ dependent.birthname }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="margin-top"></div>

        <slot-information></slot-information>

        <!-- Aceptación de responsabilidad -->

        <table class="table">
          <thead class="text-center alert background-main-color">
            <tr>
              <th scope="col"><small>
                  Información básica sobre Protección de Datos</small>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <small><b>Responsable:</b> Franciscanas Misioneras de María
                  (Hospital
                  Universitario San
                  Francisco de
                  Asís).</small>
              </td>
            </tr>
            <tr>
              <td>
                <small><b>Finalidad:</b> Facilitarle un medio para que pueda
                  solicitar una
                  cita.</small>
              </td>
            </tr>
            <tr>
              <td>
                <small><b>Derechos:</b> Acceso, rectificación o supresión, así como
                  otros indicados
                  en la
                  política de
                  privacidad.</small>
              </td>
            </tr>
            <tr>
              <td>
                <small><b>Información adicional:</b> Más información en la Política
                  de
                  Privacidad.</small>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="" id="privacyPolicy"
            [(ngModel)]=privacyPolicy>
          <label class="form-check-label" for="privacyPolicy">
            He leído y acepto las
            <a href="https://www.hsfda.com/politica-de-privacidad/" target="_blank">instrucciones
              del tratamiento</a> *
          </label>
        </div>
        <div class="row margin-top" *ngIf="!_userService.user">
          <div class="form-group col-md-4">
            <button class="btn btn-main-color btn-block" data-toggle="modal"
              data-target="#LoginModal" data-dismiss="modal">
              {{ 'LOGIN' | translate}}
            </button>
          </div>
          <div class="form-group col-md-4">
            <button class="btn btn-main-color btn-block" data-dismiss="modal"
              (click)="goRegister()">
              {{ 'REGISTER' | translate}}
            </button>
          </div>
          <div class="col-md-4">
            <button class="btn btn-secondary-color btn-block" data-dismiss="modal"
              (click)="cancelSelectedfreeslot()">
              {{ 'CANCEL' | translate}}
            </button>
          </div>
        </div>
        <div class="row margin-top" *ngIf="_userService.user">
          <div class="form-group col-md-6">
            <button type="submit" class="btn btn-main-color btn-block" [disabled]="!privacyPolicy"
              (click)="bookSlot(_resourceService.selectedFreeslot)">
              {{ 'BOOK' | translate}}
            </button>
          </div>
          <div class="col-md-6">
            <button class="btn btn-secondary-color btn-block" data-dismiss="modal"
              (click)="cancelSelectedfreeslot()">
              {{ 'CANCEL' | translate}}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>